import api from '@/api/fetchClient'
export default {
    GetUsers() {
        return api.get('users/get', { authorized: true })
      }
}
